import _ from 'lodash';
import {connect} from 'react-redux';

import {computeConflictingMergeValues} from '../../../../../../../../src/helpers/models/cardMergeHelpers';
import {createVisualContactModel} from '../../../../../../../../src/helpers/models/contactHelpers';
import {getCards, getContacts} from '../../../../../../../../src/store/data/dataSelectors';
import {makeGetMergeContactsSidePanelState} from '../../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerMergeContactsSelectors';
import {retryContactsManagerMergeContactsPreviewAsyncAction} from '../../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerSidePanelActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {MergeContactsSidePanelContent} from './mergeContactsSidePanelContent';

/*
 * Selectors.
 */

function makeGetConflictingMergeValues(
  getSidePanelState: ReturnType<typeof makeGetMergeContactsSidePanelState>,
) {
  return createSelector([getSidePanelState, getCards], (state, cards) => {
    if (!state || !state.previewCardMerge) {
      return undefined;
    }

    return computeConflictingMergeValues(
      state.previewCardMerge,
      _(state.cardIds)
        .map((cardId) => cards[cardId])
        .compact()
        .value(),
    );
  });
}

function makeGetVisualContact(getSidePanelState: ReturnType<typeof makeGetMergeContactsSidePanelState>) {
  return createSelector([getSidePanelState, getCards, getContacts], (state, cards, contacts) => {
    if (!state) {
      return undefined;
    }
    // TODO: Maybe look into a more robust way of doing this if the first card doesn't have a contact?
    const card = cards[state.cardIds[0]];
    if (!card) {
      return undefined;
    }
    const contact = contacts[card.contactUids[0]];
    if (!contact) {
      return undefined;
    }

    return createVisualContactModel({
      contact,
      namespace: card.namespace,
      allCards: cards,
      name: card.name,
      teammate: undefined,
    });
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => {
  const getSidePanelState = makeGetMergeContactsSidePanelState();

  return {
    sidePanelState: getSidePanelState,
    conflictingMergeValues: makeGetConflictingMergeValues(getSidePanelState),
    contact: makeGetVisualContact(getSidePanelState),
  };
});

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onRetryPreviewAsync: retryContactsManagerMergeContactsPreviewAsyncAction,
}));

export const MergeContactsSidePanelContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MergeContactsSidePanelContent);
